import { HTMLProps } from 'react'
import clsx from 'classnames'
import Image from 'next/image'
import { motion } from 'framer-motion'
import { Text } from '@/shared/ui'
import { IGoal } from '@/interfaces/goals'
import { useAppearance } from '@/shared/utils'
import { variantsHeadline } from '@/shared/constants/variants'
import style from './features.module.scss'

type FeaturesProps = HTMLProps<HTMLDivElement> & { goals: IGoal[] }

export const Features = ({ className, goals }: FeaturesProps) => {
  const { ref, animate } = useAppearance()

  return (
    <motion.ul ref={ref} animate={animate} className={clsx(className, style.container)} variants={variantsHeadline}>
      {goals.map(({ title, image }) => {
        return (
          <li className={style.card} key={image?.id}>
            {image?.url && (
              <div className={style.svg}>
                <Image src={image.url} alt={image?.title ?? ''} fill style={{ objectFit: 'cover' }} />
              </div>
            )}
            <Text className={style.text} color="white" type="t2" tagName="span" __html={title} />
          </li>
        )
      })}
    </motion.ul>
  )
}
